import React from 'react';

interface TextFieldErrorWarningMessageProps {
  errorMessage: string | undefined;
  validationErrorMessage: string | undefined;
  warningMessage: string | undefined;
  /**
   * Optionally render an empty message, purely used for spacing purposes along with
   * horizontal captions.
   */
  stub: boolean | undefined;
}

/**
 * Determines whether the error or warning message should be shown and
 * returns the respective component to display it.
 */
function TextFieldErrorWarningMessage({
  errorMessage,
  validationErrorMessage,
  warningMessage,
  stub,
}: TextFieldErrorWarningMessageProps): JSX.Element | null {
  if (stub) {
    return (
      <p className="error-message text-style-caption" data-testid="textfield-error-message-stub" />
    );
  } else if (validationErrorMessage || errorMessage) {
    return (
      <p className="error-message text-style-caption" data-e2e="textfield-error-message">
        {errorMessage || validationErrorMessage}
      </p>
    );
  } else if (warningMessage) {
    return (
      <p className="warning-message text-style-caption" data-e2e="textfield-warning-message">
        {warningMessage}
      </p>
    );
  } else {
    return null;
  }
}

export default TextFieldErrorWarningMessage;
